import { render, staticRenderFns } from "./SmartHome.vue?vue&type=template&id=00c898ba&"
import script from "./SmartHome.vue?vue&type=script&lang=js&"
export * from "./SmartHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev ii\\my work\\seo-team-flow\\vue templates\\Vuetify Soft UI Dashboard PRO\\seo-team-flow-ii\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c898ba')) {
      api.createRecord('00c898ba', component.options)
    } else {
      api.reload('00c898ba', component.options)
    }
    module.hot.accept("./SmartHome.vue?vue&type=template&id=00c898ba&", function () {
      api.rerender('00c898ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Dashboard/SmartHome.vue"
export default component.exports